module.exports = __webpack_public_path__ + "fb6bded282f082bb0f87664838b51d8e.MP3";